/**
 * @description 获取旅客类型
 * @param {number | string} type
 * @returns {string} 对应类型描述
 */
export default function getPsgType(type) {
    type = typeof type === 'string' ? Number(type) : type;
    if (type === 1 || type === 2) {
        return '儿童';
    }
    else if (type === 3) {
        return '婴儿';
    }
    else if (type === 0 || type === 5 || type === 6) {
        return '成人';
    }
    return '';
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/getPsgType.js
// module id = null
// module chunks = 